import { SHOW_CUSTOMIZEDMESSAGE, HIDE_CUSTOMIZEDMESSAGE,UPDATE_CUSTOMIZEDMESSAGE_DATA } from "../Actions/CustomizedMessage.action";
const defaultState = {
  showMessage: false,
  message:"",
  icon:"",
  color:"",
  textcolor:""
};

export const CustomizedMessage = (state = defaultState, action) => {
  switch (action.type) {
    case SHOW_CUSTOMIZEDMESSAGE:
      return {
        ...state,
        ...action.payload,
        showMessage: true,
      };
    case HIDE_CUSTOMIZEDMESSAGE:
      return {
        ...state,
        ...action.payload,
        showMessage: false,
      };
    case UPDATE_CUSTOMIZEDMESSAGE_DATA:
      return {
        ...state,
        message: action.payload.message,
        icon: action.payload.icon,
        color:action.payload.color,
        textcolor:action.payload.textcolor,
        showMessage: true,
      };
    default:
      return state;
  }
};
